import loadable from '@loadable/component';
import LoadingComponentLoadable from '../../../components/Loading/Lazy';

const GeneralServiceLoadable = loadable(() => import(/* webpackChunkName: "general-service-page" */ './index'), {
  fallback: <LoadingComponentLoadable />,
});

export default GeneralServiceLoadable;
